module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminextraescolares-grupos/adminextraescolares-grupos.component.scss
// module id = ./src/app/adminextraescolares-grupos/adminextraescolares-grupos.component.scss
// module chunks = main